import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { fetchInvoicePdfBlob } from "@/lib/invoiceDoc";

// Dedicated, chrome-free page for "Open in new tab". Shows ONLY the invoice
// document (the same backend-rendered PDF) — no sidebar, no app navigation.
export default function InvoicePreviewPage() {
  const { invoiceId } = useParams();
  const [blobUrl, setBlobUrl] = useState(null);
  const [error, setError] = useState(null);
  const urlRef = useRef(null);

  useEffect(() => {
    document.title = "Invoice";
    let revoked = false;
    fetchInvoicePdfBlob(invoiceId, "digital")
      .then((blob) => {
        if (revoked) return;
        const url = URL.createObjectURL(blob);
        urlRef.current = url;
        setBlobUrl(url);
      })
      .catch(() => {
        if (!revoked) setError("Unable to load this invoice. Please sign in and try again.");
      });
    return () => {
      revoked = true;
      if (urlRef.current) URL.revokeObjectURL(urlRef.current);
    };
  }, [invoiceId]);

  if (error) {
    return (
      <div style={{ minHeight: "100vh", display: "grid", placeItems: "center",
                    fontFamily: "system-ui, sans-serif", color: "#8a3f1e", background: "#F2F0EB" }}
           data-testid="invoice-preview-page-error">
        {error}
      </div>
    );
  }

  return (
    <div style={{ width: "100vw", height: "100vh", background: "#525659" }}
         data-testid="invoice-preview-page">
      {!blobUrl && (
        <div style={{ minHeight: "100vh", display: "grid", placeItems: "center",
                      color: "#e8e8e8", fontFamily: "system-ui, sans-serif", fontSize: 14 }}
             data-testid="invoice-preview-page-loading">
          Rendering invoice…
        </div>
      )}
      {blobUrl && (
        <iframe
          title="Invoice document"
          src={blobUrl}
          style={{ width: "100%", height: "100%", border: 0 }}
        />
      )}
    </div>
  );
}
